<template>
  <div
    v-tooltip="{
      content: translate('spaceDetails'),
      placement: 'bottom',
    }"
    class="flex items-center justify-center h-8 w-8 pt electron-no-drag"
    :class="{ 'bg-icon-bg': displayInfoSidebar }"
    @touchstart.prevent.stop="handleClick"
    @click="handleClick"
    @mouseover="mouseOverHandler"
  >
    <em
      :style="getCustomIconStyle(iconPath('info'))"
      class="custom-icons sidebar-icon bg-icon-default"
    />
  </div>
</template>

<script>
import pageNotFound from '@/mixins/pageNotFound';
import customIconMixin from '@/mixins/customIconsMixin';
import reportingMixin from '@/mixins/reportingMixin';

export default {
  name: 'SidebarHeaderButton',
  mixins: [pageNotFound, customIconMixin, reportingMixin],
  computed: {
    displayInfoSidebar() {
      return this.$store.getters.displayInfoSidebar;
    },
    reportInfoData() {
      return this.$store.getters.getReportInfoData;
    },
    currentBoardId() {
      return this.$store.getters.currentBoard.id;
    },
  },
  methods: {
    mouseOverHandler() {
      if (!Object.keys(this.reportInfoData[this.currentBoardId] || {}).length) {
        this.fetchReportInfoData();
      }
    },
    fetchReportInfoData() {
      this.getLastNDays(7);
      this.fetchReportData();
    },
    handleClick() {
      if (this.pageNotFound) return;
      this.$store.dispatch('displayInfoSidebar', !this.displayInfoSidebar);
      if (this.displayInfoSidebar && this.$route.name === this.$constants.routeNames.board) {
        this.fetchReportInfoData();
      }
    },
  },
};
</script>
